import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlightTravellers from 'components/widgets/flightTravellers';
import FlightRoundTrip from 'components/widgets/engines/flightRoundTrip';
import FlightOneway from 'components/widgets/engines/flightOneway';
import FlightOpenJaw from 'components/widgets/engines/flightOpenJaw';
import FlightMultiCity from 'components/widgets/engines/flightMultiCity';
import FlightCarriers from 'components/widgets/autocompletes/flightCarriers';
import buildQueryString from 'helpers/buildQueryString';
import ErrorHandler from 'libraries/errorHandler';
import moment from 'moment';
import Lang from 'libraries/Lang';
import LoadingModal from '../../../helpers/loadingModal';

class Flights extends Component {
    constructor(props) {
        super(props);

        const agent = document.getElementById('AccountData').getAttribute('value');
        let agentData = null;
        if (agent !== '' && agent !== null) {
            agentData = JSON.parse(agent);
        }
        const stateValue = {
            legs: [{
                key: '1',
                startDate: null,
                endDate: null,
                departure: null,
                destination: null,
            }, {
                key: '2',
                startDate: null,
                endDate: null,
                departure: null,
                destination: null,
            }],
            travellers: {
                adults: 1,
                children: [],
            },
            trip: 'GiGi',
            showTravellers: false,
            cabin: '',
            changesAllowed: '',
            maxConnections: 2,
            carriers: [],
            nearByAirport: false,
            atLeastFreeBaggage: false,
            multicityPricing: false,
            basicEconomyFares: false,
            airFare: true,
            landFare: false,
            cruiseFare: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
            loadingModel: false,
            gigiLink: document.getElementById("GiGiurl") != null ? document.getElementById("GiGiurl").value+'&token=' + props.Traveltoken : null,
            gigiUSDLink: document.getElementById("GiGiUSDUrl") != null ? document.getElementById("GiGiUSDUrl").value +'&token=' + props.Traveltoken + '&flightType=USD' : null,
            gigiSection: document.getElementById("gigiSection") != null ? document.getElementById("gigiSection").value : 'N'
        };

        const storage = localStorage.getItem('flightEngine');
        try {
            if (storage !== null && storage.length > 0) {
                Object.assign(stateValue, JSON.parse(storage));

                stateValue.legs = stateValue.legs.map((leg) => {
                    const newLeg = Object.assign({}, leg);

                    if (leg.endDate !== null) {
                        newLeg.endDate = moment(leg.endDate);
                    }

                    if (leg.startDate !== null) {
                        newLeg.startDate = moment(leg.startDate);
                    }

                    return newLeg;
                });
                if (stateValue.date !== null) {
                    stateValue.date = moment(stateValue.date);
                }
            }
        } catch (e) {
            localStorage.removeItem('flightEngine');
        }

        this.state = stateValue;

        const rules = {
            'form.departure': (departure) => {
                let valid = true;

                if (departure === null || Object.keys(departure).length === 0) {
                    valid = 'Select a departure';
                }

                return valid;
            },

            'form.destination': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    valid = 'Select a destination';
                }

                return valid;
            },
            'travellers.childAge': (age, key, index) => {
                let valid = true;

                if (age === '') {
                    valid = `child ${index + 1} in room ${key + 1} needs an age`;
                }
                return valid;
            },
            'form.dates': (dates) => {
                let valid = true;
                if (dates.depDate === null || dates.retDate === null) {
                    valid = 'Please selected a valid departure and return date';
                }
                return valid;
            },
            'form.date': (date) => {
                let valid = true;
                if (date === null) {
                    valid = 'Please selected a valid travel date';
                }
                return valid;
            },
        };

        this.errorHandler = new ErrorHandler(rules);

        this.toggleTravellers = this.toggleTravellers.bind(this);
        this.handleTravellerBlur = this.handleTravellerBlur.bind(this);
        this.changeTrip = this.changeTrip.bind(this);
        this.changeTravellers = this.changeTravellers.bind(this);
        this.legChanged = this.legChanged.bind(this);
        this.swapLocations = this.swapLocations.bind(this);
        this.changeCabin = this.changeCabin.bind(this);
        this.changeItems = this.changeItems.bind(this);
        this.selectCarriers = this.selectCarriers.bind(this);
        this.changePanClude = this.changePanClude.bind(this);
        this.changeFareType = this.changeFareType.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleTravellerBlur(event) {
        let node = event.target;

        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideTravellers();
        }
    }

    toggleTravellers(occupancyOpen) {
        if (occupancyOpen) {
            this.showTravellers();
        } else {
            this.hideTravellers();
        }
    }

    hideTravellers() {
        const app = document.getElementById('app');
        app.removeEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: false });
    }

    showTravellers() {
        const app = document.getElementById('app');
        app.addEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: true });
    }

    changeTravellers(travellers) {
        this.setState({ travellers });
    }

    legChanged(legs, element) {
        const { shouldValidate, trip } = this.state;

        // check validation before updating state
        if (shouldValidate) {
            const parts = element.split('-');
            const leg = legs.find((option) => option.key === parts[1]);

            if (parts.length === 2) {
                if (parts[0] === 'departure') {
                    this.errorHandler.checkRule(`form.departure-${leg.key}`, leg.departure);
                } else if (parts[0] === 'destination') {
                    this.errorHandler.checkRule(`form.destination-${leg.key}`, leg.destination);
                } else if (parts[0] === 'date') {
                    if (trip === 'roundtrip') {
                        this.errorHandler.checkRule(`form.dates-${leg.key}`, { depDate: leg.startDate, retDate: leg.endDate });
                    } else {
                        this.errorHandler.checkRule(`form.date-${leg.key}`, leg.startDate);
                    }
                }
            } else {
                this.errorHandler.clear(`form.departure-${element}`);
                this.errorHandler.clear(`form.destination-${element}`);
                this.errorHandler.clear(`form.date-${element}`);
            }
        }

        this.setState({ legs });
    }

    changeTrip(event) {
        const { legs } = this.state;
        const { target } = event;

        this.setState({ trip: target.value });
    }

    swapLocations(index) {
        const { legs } = this.state;

        const newLeg = Object.assign({}, legs[index]);

        newLeg.departure = legs[index].destination;
        newLeg.destination = legs[index].departure;

        const newLegs = [...legs.splice(0, index), newLeg, ...legs.splice(index + 1)];

        this.setState({ legs: newLegs });
    }

    changeCabin(event) {
        const { target } = event;
        this.setState({ cabin: target.value });
    }

    changeItems(item, event) {
        const { value } = event.target;

        if (item === 'changesAllowed') {
            const { changesAllowed } = this.state;
            this.setState({ changesAllowed: value });
        } else if (item === 'maxConnections') {
            const { maxConnections } = this.state;
            this.setState({ maxConnections: value });
        }
    }

    selectCarriers(value) {
        this.setState({ carriers: value });
    }

    changePanClude(item) {
        if (item === 'nearByAirport') {
            const { nearByAirport } = this.state;
            this.setState({ nearByAirport: !nearByAirport });
        } else if (item === 'atLeastFreeBaggage') {
            const { atLeastFreeBaggage } = this.state;
            this.setState({ atLeastFreeBaggage: !atLeastFreeBaggage });
        } else if (item === 'multicityPricing') {
            const { multicityPricing } = this.state;
            this.setState({ multicityPricing: !multicityPricing });
        } else if (item === 'basicEconomyFares') {
            const { basicEconomyFares } = this.state;
            this.setState({ basicEconomyFares: !basicEconomyFares });
        }
    }

    changeFareType(fareType) {
        if (fareType === 'air') {
            const { airFare } = this.state;
            this.setState({ airFare: !airFare });
        } else if (fareType === 'land') {
            const { landFare } = this.state;
            this.setState({ landFare: !landFare });
        } else if (fareType === 'cruise') {
            const { cruiseFare } = this.state;
            this.setState({ cruiseFare: !cruiseFare });
        }
    }

    submit(flag, event) {
        event.preventDefault();
        this.setState({ loadingModel: true });

        const {
            travellers,
            carriers,
            trip,
            cabin,
            legs,
            Traveltoken,
            TravelRedirect,
            gigiUSDLink,
            gigiLink
        } = this.state;

        let url = '';

        if (trip == 'CAD') {
            url = document.getElementById('flightCADUrl').value+'&B2B='+Traveltoken;

//            const flightsCADElement = document.getElementById('flightCADUrl');
        } else if (trip == 'USD') {
            url = document.getElementById('flightUSDUrl').value+'&B2B='+Traveltoken;
            //url = `${flightsUSDElement.getAttribute('value')'&B2b='${Traveltoken}}`;
        } else if (trip == 'GigiUSD') {
            url = gigiUSDLink
        } else {
            url = gigiLink;
        }
        // let url = TravelRedirect+"/?t=" + Traveltoken;
        window.location.href = url;
        console.log('url', url);
        // window.location.href = url;
        return false;
    }

    render() {
        
        const {
            legs,
            cabin,
            trip,
            travellers,
            showTravellers,
            changesAllowed,
            maxConnections,
            carriers,
            nearByAirport,
            atLeastFreeBaggage,
            multicityPricing,
            basicEconomyFares,
            airFare,
            landFare,
            cruiseFare,
            loadingModel,
            gigiLink,
            gigiUSDLink,
            gigiSection
        } = this.state;
        const errors = this.errorHandler.getErrors();

        return (
            <>
                <LoadingModal isLoading={loadingModel} />
                <form className="search-flight" action="">
                    <input type="hidden" name="request" value="" />
                    <div className="row gutter-10 mb-3 text-center">
                        <div className="col-12">
{/* 
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-roundtrip" name="trip" value="CAD" onChange={this.changeTrip} checked={trip === 'CAD'} />
                            <label htmlFor="radio-roundtrip"><span>{Lang.trans('engine.flights')} CAD</span></label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-oneway" name="trip" value="USD" onChange={this.changeTrip} checked={trip === 'USD'} />
                            <label htmlFor="radio-oneway"><span>{Lang.trans('engine.flights')} USD</span></label>
                        </div>

                        { gigiLink != null && gigiSection == 'Y' && <div className="styled-radio black-text">
                            <input type="radio" id="radio-gigi" name="gigi" value="GiGi" onChange={this.changeTrip} checked={trip === 'GiGi'} />
                            <label htmlFor="radio-gigi"><span>GiGi</span></label>
                        </div> } */}

                            <div className={"d-inline-flex border rounded-sm col-lg-8 p-0 mt-4 flight-box " + (gigiSection == 'Y' ? '' : 'justify-content-center')}>
                                <div className={"p-4 border border-secondary rounded-sm-left col-md-6 " + (gigiSection == 'Y' ? '' : 'd-none')}>
                                    <span className="bg-white border border-secondary px-3 py-2 py-1 text-primary font-weight-bold h5 position-absolute badge mx-auto">{Lang.trans('engine.new')}</span>
                                    <div className="d-inline-block">
                                    <div className="text-primary font-weight-bold mb-3 mt-3 h6">
                                    {Lang.trans('engine.gigi_tool')}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        {gigiLink != null && <div className="styled-radio black-text">
                                            <input type="radio" id="radio-gigi" name="gigi" value="GiGi" onChange={this.changeTrip} checked={trip === 'GiGi'} />
                                            <label htmlFor="radio-gigi" className="pr-0"><span>CAD</span></label>
                                        </div>}

                                        {gigiUSDLink != null && <div className="styled-radio black-text">
                                            <input type="radio" id="radio-gigiusd" name="gigiusd" value="GigiUSD" onChange={this.changeTrip} checked={trip === 'GigiUSD'} />
                                            <label htmlFor="radio-gigiusd" className="pr-0"><span>USD</span></label>
                                        </div>}
                                    </div>
                                   
                                    </div>
                                </div>
                                <div className="p-4 col-md-6">
                                    <div className="text-primary font-weight-bold mb-3 mt-3 h6">
                                    {Lang.trans('engine.current_air_tool')}
                                    </div>
                                    <div className="styled-radio black-text">
                                        <input type="radio" id="radio-roundtrip" name="trip" value="CAD" onChange={this.changeTrip} checked={trip === 'CAD'} />
                                        <label htmlFor="radio-roundtrip"><span>{Lang.trans('engine.flights')} CAD</span></label>
                                    </div>
                                    <div className="styled-radio black-text">
                                        <input type="radio" id="radio-oneway" name="trip" value="USD" onChange={this.changeTrip} checked={trip === 'USD'} />
                                        <label htmlFor="radio-oneway"><span>{Lang.trans('engine.flights')} USD</span></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="row gutter-10 border-top">
                        <div className="col-12 text-center mt-2 mt-2 pt-2">
                            <button type="button" className="btn btn-primary btn-lg px-5 font-weight-600 mx-md-2" onClick={(e) => this.submit('', e)}>
                                <span className="">{Lang.trans('buttons.search')}</span>
                            </button>
                        </div>
                    </div>
                </form>
            </>
        );
    }
}

export default Flights;
